import type {FC} from 'react';
import {routes} from '../../../config/constants';
import {CommonLink} from '../../../shared/components/CommonLink';

type Props = {
  linkClassName: string;
  mailAuthLink: string;
};

export const RegisterBodyNew: FC<Props> = ({linkClassName, mailAuthLink}) => {
  return (
    <>
      <p className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
        1.会員登録
      </p>
      <div id="a1" className="mt-16">
        <h3>
          <span>Q.</span>会員登録をしたい
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          <CommonLink
            href={mailAuthLink}
            target="_blank"
            className={linkClassName}
          >
            新規会員登録画面
          </CommonLink>
          より、ログイン用メールアドレス（普段お使いのメールアドレス）を入力し、本登録の手続きを行ってください。
        </p>
        <p className="mt-8">
          学生であることの証明として、以下いずれかの方法をご案内しています（いずれも任意です）。
          <br />
          ●大学から発行されたメールアドレスを登録する
          <br />
          ●学生証画像をアップロードし、審査を受ける
          <br />
          ※いずれも会員登録の完了後、ログインした状態でお手続きいただけます。
          <br />
          ※いずれも行われない場合、会員限定コンテンツなど一部機能のご利用に制限がかかります。
        </p>
        <p className="mt-8">
          海外の大学に在籍されている方も、上記と同じ手順でログイン用メールアドレスによる会員登録が可能です。学生確認は、まずご所属の大学から発行されたメールアドレスをマイページよりご登録ください。
          <br />
          ※大学メールアドレスでの学生確認がうまくいかない場合は、ログインの上、
          <CommonLink
            href={routes.INQUIRY_FOREIGN_UNIV}
            target="_blank"
            className={linkClassName}
          >
            海外大学申請フォーム
          </CommonLink>
          より手続きを行うことができます。
        </p>
      </div>
      <div id="a2" className="mt-16">
        <h3>
          <span>Q.</span>
          大学発行のメールアドレスを持っていない場合の学生確認方法
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          大学発行のメールアドレスの登録は任意です。お持ちでない場合は、学生証画像をアップロードいただくことで学生確認を行うことができます。
        </p>
        <p className="mt-8">
          学生証による確認は、ログインの上、
          <CommonLink
            href={routes.STUDENT_CARD}
            target="_blank"
            className={linkClassName}
          >
            こちら
          </CommonLink>
          から行えます。
          <br />
          ※画像審査には通常1週間ほどお時間を頂戴いたします。なお、学生証による確認は会員登録の完了後に行う任意の手続きであり、会員登録そのものには影響しません。
        </p>
        <p className="mt-8">
          学生証に関する受付完了メールが届かない場合、または一週間以上経過しても審査結果が届かない場合は、
          <CommonLink
            href={routes.INQUIRY}
            target="_blank"
            className={linkClassName}
          >
            こちら
          </CommonLink>
          から件名「学生証審査について」を選択し、お困りの内容をご連絡ください。
          <br />
          ※大学メールアドレスの登録・学生証による確認のいずれも行われない場合、会員限定コンテンツなど一部機能のご利用に制限がかかります。
        </p>
      </div>

      <div id="a3" className="mt-16">
        <h3>
          <span>Q.</span>
          新規会員登録画面で「そのメールアドレスはすでに登録されています」と表示される
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          入力したメールアドレスは、既に登録が完了しております。
        </p>
        <p>
          パスワードを忘れてしまった場合は
          <CommonLink href="#b1" className={linkClassName}>
            パスワードを忘れた・変更したい
          </CommonLink>
          をご覧ください。
        </p>
      </div>

      <div id="a4" className="mt-16">
        <h3>
          <span>Q.</span>
          本登録用URLが記載されたメールが届かない
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          会員登録時の受信確認メールについて、以下をご確認ください。
        </p>
        <p>
          (1) 入力したメールアドレスに誤りがないかどうかのご確認
          <br />
          誤りがある場合、正しいメールアドレスで再度登録を行ってください。
        </p>
        <p className="mt-4">
          【よくある間違い】
          <br />
          ●ピリオドがカンマになっている
          <br />
          ●全角文字が含まれている
        </p>
        <p className="mt-8">
          (2) メールフィルター誤作動のご確認
          <br />
          返信メールがフィルターに弾かれ、「迷惑メールフォルダ」などに入ってしまっている可能性がございます。それらのフィルターが誤作動していないかご確認ください。
        </p>
        <p className="mt-4">
          なお、Office365などのサーバーでは、メールを「ブロックまたは許可する」というリストの編集をすることができます。以下のメールアドレスを受信許可リストにご登録いただくことで、メールの受信が可能になることがあります。
          <strong>
            <br />
            info@gaishishukatsu.com
          </strong>
        </p>
        <p className="mt-8">
          (3) お使いのメールボックスの容量のご確認
          <br />
          メールボックスの容量を増やすか、不要データを削除した後、再度登録を行ってください。
        </p>
        <p className="mt-8">
          大学メールアドレスを追加で登録される場合は、以下もあわせてご確認ください。
          <br />
          (4) 転送先受信設定のご確認
          <br />
          大学のメールアドレスに届いたメールをスマートフォンなどに転送して確認されている場合、スマートフォン側の迷惑メールの設定により、転送先のサーバーでメールがブロックされてしまっていることがあります。
          <br />
          ブロックを防止するためには、迷惑メールフィルターの設定画面より、「救済リスト」もしくは「受信リスト」に以下メールアドレスのご登録をお願いいたします。
          <strong>
            <br />
            info@gaishishukatsu.com
          </strong>
        </p>
        <p className="mt-8">
          (5) 他メールソフト設定のご確認
          <br />
          他のメールソフトで大学のメールアドレスに届いたメールを確認されている場合、メールを「サーバーに残さない」設定にしていると、一度確認されたメールが削除されてしまいます。「サーバーに残す」設定になっているかご確認ください。
        </p>
        <p className="mt-8">
          (6) 学外からのメールが届かない設定になっていないかどうかのご確認
          <br />
          一部の大学では、大学ドメイン以外からの受信ができないメールアドレスがある場合がございます。大学のメール利用ガイドをご確認ください。
        </p>
      </div>

      <div id="a5" className="mt-16">
        <h3>
          <span>Q.</span>
          大学メールアドレスを後から追加登録したい
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          マイページの
          <CommonLink
            href={routes.PROFILE_AC_EMAIL}
            target="_blank"
            className={linkClassName}
          >
            「大学メールアドレスの編集」
          </CommonLink>
          より、大学メールアドレスを追加で登録することができます。大学メールアドレスをご登録いただくと学生であることの証明となり、会員限定コンテンツの制限が解除されます。
        </p>
      </div>

      <div id="a6" className="mt-16">
        <h3>
          <span>Q.</span>既卒だが会員登録をしたい
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          申し訳ございませんが、当サイトは学生の方の登録に限定しております。対象となるのは、四年制大学、大学院、高専本科4年次以降、情報系専攻の短期大学・専門学校に在籍されている方です。ご了承ください。
        </p>
      </div>

      <div id="a7" className="mt-16">
        <h3>
          <span>Q.</span>
          学生証確認の結果、他の会員と重複していると言われた
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          送信いただいた学生証の氏名・生年月日・ご所属の大学が、既に別のアカウントで完了している学生確認の情報と一致した場合、学生確認を完了することができません。
        </p>
        <p className="mt-8">
          外資就活ドットコムでは、お一人につき1つのアカウントでの学生確認をお願いしております。
          <br />
          ※お心当たりがない場合や、ご自身の情報に誤りがある場合は、
          <CommonLink
            href={routes.INQUIRY}
            target="_blank"
            className={linkClassName}
          >
            お問い合わせフォーム
          </CommonLink>
          より「学生証による学生確認について」をお選びいただき、詳細をご連絡ください。
        </p>
      </div>
    </>
  );
};
